import { render } from "./MBAFaqView.vue?vue&type=template&id=4bf4516e"
import script from "./MBAFaqView.vue?vue&type=script&lang=js"
export * from "./MBAFaqView.vue?vue&type=script&lang=js"

import "./MBAFaqView.vue?vue&type=style&index=0&id=4bf4516e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__